import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

import { RootStateBase } from "base/src/store/baseStore";
import { CarteiraBaseReducer } from "domain/store/_carteira/carteiraBase/reducers/carteiraBaseReducers";
import { PremiacaoReducer } from "domain/store/_carteira/premiacao/reducers/premiacaoReducer";

import { CampanhaPedidoResgateReducer } from "domain/store/_carteira/campanhaPedidoResgate/reducers/campanhaPedidoResgateReducer";

const homeInfoPersistConfig = {
    key: "homeInfo",
    storage,
    whitelist: ["CarteiraUsuario"],
};

const persistedReducer = persistReducer(
    homeInfoPersistConfig,
    CarteiraBaseReducer
);

export const CarteiraBaseReducerList = {
    CarteiraBaseReducer: persistedReducer,
    PremiacaoReducer,
    CampanhaPedidoResgateReducer
};


const CarteiraMasterReducer = combineReducers(CarteiraBaseReducerList);
export default CarteiraMasterReducer;

export type RootStateBaseCarteira = RootStateBase & ReturnType<typeof CarteiraMasterReducer>;
